import isNil from "lodash/isNil";

import { ScheduleAnalyticsEvent } from "@/constants/analytics/Scheduling";
import { ScheduleTabSubDeepLinks } from "@/constants/Schedule";
import useScheduleEventDetailsSubDeepLink from "@/hooks/deepLinking/subDeepLinks/useScheduleEventDetailsSubDeepLink";
import useEncodedSearchParams from "@/hooks/useEncodedSearchParams";
import { useGetGroupClassEventQuery } from "@/store/api/schedule/schedule";

const useGroupClassEventSubDeepLink = () => {
  const { groupClassEventExternalId } = useEncodedSearchParams<{
    groupClassEventExternalId?: string;
  }>();

  const {
    data: groupClassEvent,
    error,
    isFetching,
  } = useGetGroupClassEventQuery(
    groupClassEventExternalId ?? "",
    // eslint-disable-next-line @typescript-eslint/naming-convention -- RTK Query option name
    { skip: isNil(groupClassEventExternalId) },
  );

  useScheduleEventDetailsSubDeepLink({
    analyticsEvent: ScheduleAnalyticsEvent.GroupClassEventOpenedFromDeepLink,
    appointmentMetaData: undefined,
    data: groupClassEvent,
    error,
    errorLabel: "group class event",
    isFetching,
    isGroupClassEvent: true,
    modalTitle: "Event details",
    paramKey: "groupClassEventExternalId",
    paramValue: groupClassEventExternalId,
    targetValue: ScheduleTabSubDeepLinks.GroupClassEvent,
  });
};

export default useGroupClassEventSubDeepLink;
